import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

export default class extends Controller {
  static targets = ["pin", "border", "topline", "archive", "imgWrapper"]

  connect() {
    history.scrollRestoration = "manual";
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

    this.smoother = ScrollSmoother.create({
        wrapper: "#container",
        content: "#smooth-content",
        smooth: 1.5,
        effects: true,
        normalizeScroll: false
    });

    this.initAnimations()

    if(this.hasArchiveTarget){
      this.archiveTimeline()
      this.checkInitialHash()
    }
  } // content

  initAnimations() {
    const kv = document.getElementById("kv-video")
    if (kv) {
      const kvCard = document.querySelector("#kv-card");
      if(kvCard) {
        this.kvTween = gsap.fromTo(kvCard,
          { clipPath: "inset(0% 40%)" },
          {
            clipPath: "inset(0% 0%)",
            ease: "none",
            scrollTrigger: {
              trigger: document.querySelector("body"),
              start: "top top",
              end: "+=100%",
              scrub: true,
              invalidateOnRefresh: true
            }
          }
        );
      }
    } // end kv

    if (this.hasToplineTarget) {
      this.toplineTargets.forEach((topline) => {
        ScrollTrigger.create({
          trigger: topline,
          start: "top 50%",
          onEnter: () => {
            topline.classList.add("show")
          },
          onLeaveBack: () => {
            topline.classList.remove("show")
          }
        });
      })
    }
    
    if (this.hasBorderTarget) {
      this.borderTargets.forEach((border) => {
        ScrollTrigger.create({
          trigger: border,
          start: "top 50%",
          onEnter: () => {
            border.querySelectorAll(".border-line").forEach((line) => {
              line.classList.add("show")
            })
          },
          onLeaveBack: () => {
            border.querySelectorAll(".border-line").forEach((line) => {
              line.classList.remove("show")
            })
          }
        });
      })
    } // end border

    if (this.hasImgWrapperTarget) {
      this.imgWrapperTargets.forEach((imgWrapper) => {
        ScrollTrigger.create({
          trigger: imgWrapper,
          start: "top 40%",
          onEnter: () => {
            imgWrapper.querySelector(".image-overlay").classList.add("show")
          }
        });
      })
    } // end imgTarget

    if (this.hasPinTarget) {
      this.pinTrigger = ScrollTrigger.create({
        trigger: this.element,
        pin: this.pinTarget,
        start: "top 70%",
        end: "+=100%",
        invalidateOnRefresh: true
      });
    }

    window.addEventListener("resize", () => {
      ScrollTrigger.refresh();
    });
  } // end initAnimations

  scrollto(e){
    if (this.hasArchiveTarget) {
      const menuOverlay = document.getElementById('menu-overlay')
      if(menuOverlay.classList.contains('active')){
        menuOverlay.classList.remove('active')
        document.body.style.overflow = ''
      }
      this.scrollToArchive(e)
    }
  } // end scrollto

  archiveTimeline(){
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.archiveTarget,
        start: "top 70%",
        toggleActions: "play none none none"
      }
    });

    tl.from(".archive-hr", {
      scaleX: 0,
      transformOrigin: "left center",
      duration: 1.2,
      ease: "power3.out"
    });

    tl.from(".archive-year", {
      y: 40,
      opacity: 0,
      stagger: 0.15,
      duration: 0.8,
      ease: "back.out(1.7)"
    }, "-=0.5");
  } // end archiveTimeline

  checkInitialHash() {
    if (window.location.hash === "#archive") {
      gsap.delayedCall(0.1, () => {
        this.scrollToArchive()
      })
    }
  }

  scrollToArchive(event) {
    if (event) event.preventDefault();
    
    if (this.hasArchiveTarget) {
      this.smoother.scrollTo(this.archiveTarget, true, "top 10%");
    }
  }

  disconnect() {
    if (this.smoother) {
      this.smoother.kill();
    }
    
    ScrollTrigger.getAll().forEach(t => t.kill());
  }
}